<template lang="pug">
  #app
    component(:is="component")
      slot
</template>

<script>
import { mapGetters } from "vuex";

// Import all template meeting files
import mappings from "@/mappings";

import {
  GET_SPLASH_PAGE,
  GET_MEETING,
  ADD_USER,
  APPLY_TEMPLATE_PATH,
  GET_MEETING_MOTD
} from "@/store/actions.type";

export default {
  name: "Meeting",
  components: mappings.meeting,
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "currentMeeting",
      "splashPage",
      "accessCode",
      "validCode",
      "template",
      "session",
      "motd"
    ]),
    component() {
      return this.$store.state.authentication.meetingTemplate;
    }
  },
  mounted() {
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      this.getSplashPage(id);
      this.getMeeting(id);
      this.getMotd(id);
      this.setMeetingTemplate();
    }
  },
  methods: {
    setMeetingTemplate() {
      this.$store.dispatch(APPLY_TEMPLATE_PATH, {
        template: "templates/innflux_final/"
      })
      .then((res) => {
        console.log('res is..');
        console.log(res);
      });
    },
    getMotd(meeting_id) {
      this.$store.dispatch(GET_MEETING_MOTD, {
        meeting_id: meeting_id,
        session_id: this.session.session_id
      });
    },
    getSplashPage(meeting_id) {
      this.$store.dispatch(GET_SPLASH_PAGE, {
        meeting_id: meeting_id
      });
    },
    getMeeting(meeting_id) {
      this.$store.dispatch(GET_MEETING, {
        meeting_id: meeting_id
      });
    }
  }
};
</script>

<style scoped></style>